import {
  CAMEL_BODY,
  CAPYBARA_MOUNT_BODY,
  CAT_MOUNT_BODY,
  DOBERMAN_MOUNT_BODY,
  LLAMA_BODY,
  LOWRIDER_BODY,
  MOUNTAIN_GOAT_MOUNT_BODY,
  POODLE_MOUNT_BODY,
  SAINT_BERNARD_MOUNT_BODY,
  TERATHAN_QUEEN_MOUNT_BODY,
  WEREWOLF_MOUNT_BODY,
  WOLF_MOUNT_BODY,
  mountBody,
} from './sim/content';

/** Admin-only mount choices, shared by the panel and its command adapter. */
export const ADMIN_MOUNT_OPTIONS = [
  { id: 'camel', label: 'Camel', body: CAMEL_BODY },
  { id: 'llama', label: 'Llama', body: LLAMA_BODY },
  { id: 'cat', label: 'Cat', body: CAT_MOUNT_BODY },
  { id: 'terathan-queen', label: 'Terathan Queen', body: TERATHAN_QUEEN_MOUNT_BODY },
  { id: 'mountain-goat', label: 'Mountain Goat', body: MOUNTAIN_GOAT_MOUNT_BODY },
  { id: 'saint-bernard', label: 'St. Bernard', body: SAINT_BERNARD_MOUNT_BODY },
  { id: 'wolf', label: 'Wolf', body: WOLF_MOUNT_BODY },
  { id: 'poodle', label: 'Poodle', body: POODLE_MOUNT_BODY },
  { id: 'doberman', label: 'Doberman', body: DOBERMAN_MOUNT_BODY },
  { id: 'capybara', label: 'Capybara', body: CAPYBARA_MOUNT_BODY },
  { id: 'werewolf', label: 'Werewolf', body: WEREWOLF_MOUNT_BODY },
  { id: 'lowrider', label: 'Lowrider', body: LOWRIDER_BODY },
] as const;

export type AdminMount = (typeof ADMIN_MOUNT_OPTIONS)[number]['id'];

const ADMIN_MOUNT_BODY_BY_ID = new Map<AdminMount, number>(
  ADMIN_MOUNT_OPTIONS.map((mount) => [mount.id, mount.body]),
);

export function adminMountBody(mount: AdminMount): number {
  return ADMIN_MOUNT_BODY_BY_ID.get(mount)!;
}

/** Whether this mount keeps a seated character stack visible above its own art. */
export function adminMountShowsRider(mount: AdminMount): boolean {
  return mountBody(adminMountBody(mount))?.mountPresentation !== 'replacement';
}

export interface AdminMountRiderHeight {
  movingOffsetY: number;
  idleOffsetY: number;
}

function firstOffset(value: number | readonly number[] | undefined): number {
  return typeof value === 'number' ? value : (value?.[0] ?? 0);
}

/** Uniform starting values for the admin's live rider-height tuning controls. */
export function adminMountRiderHeight(mount: AdminMount): AdminMountRiderHeight {
  const definition = mountBody(adminMountBody(mount))!;
  const movingOffsetY = firstOffset(definition.riderOffsetY);
  return {
    movingOffsetY,
    idleOffsetY:
      definition.riderIdleOffsetY === undefined
        ? movingOffsetY
        : firstOffset(definition.riderIdleOffsetY),
  };
}
